import LanguageIcon from '@mui/icons-material/LanguageRounded'

export default LanguageIcon
